/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
// @material-ui/core components
import { red } from '@material-ui/core/colors';
import axios from 'axios';
import {
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper, TableSortLabel, TableFooter, TablePagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';

import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import Typography from "@material-ui/core/Typography";
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import { VehicleAdminGuard } from "./vehicleAuth";

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    FormGroup, Label, Input,
    Row,
    InputGroupAddon,
    InputGroupText,
    InputGroup
} from 'reactstrap';

// core components
import Grid from "components/Grid/GridContainer";

import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardContent from "@material-ui/core/CardContent";
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button2 from "components/CustomButtons/Button.js";
import { authHeader } from "_helpers";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSUser from "components/Forms/TSUser";
import "react-datetime/css/react-datetime.css"
import "./custom-style.css";
import { color } from "highcharts";

const useStyles = makeStyles((theme) => ({
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
        flexGrow: 1,
    },
    cardTitle: {
        textAlign: 'center'
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none",
        flexGrow: 1,
    },
    collaps: {
        paddingLeft: '40px',
        paddingTop: '40px',
        display: 'flex',
        flexDirection: 'column-reverse',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        ...StyleSheet.absoluteFillObject,
        alignSelf: 'flex-end',
        position: 'absolute', // add if dont work with above
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    visible: {
        opacity: 1,
        transition: 'opacity 0.5s ease'
    },
    hidden: {
        opacity: 0,
        transition: 'opacity 0.5s ease'
    },
    avatar: {
        backgroundColor: red[500],
    },
    tableContainer: {
        width: '99.99%',
        overflowX: 'auto', // ทำให้ตารางสามารถเลื่อนในแนวนอนเมื่อกว้างเกินไป
    },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    tableCell: {
        padding: '2px',
    },
    modalFullscreen: {
        width: '100%',
        height: '100%',
        margin: 0,
        maxWidth: '100%',
    },
    modalContent: {
        height: '100%',
        borderRadius: 0,
    },
    modalBody: {
        overflowY: 'auto',
    },
    pagination: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
    cardXs: {
        width: 75,
        height: 110,
        paddingTop: 10,
        margin: 2,
        textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardSm: {
        width: 180,
        height: 140,
        textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardImg1: {
        width: 60, height: 60, borderRadius: 60 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
    cardImg2: {
        width: 100, height: 100, borderRadius: 100 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
}));

const VehicleTypeList = (props) => {
    const tableText = 'ประเภทของยานพาหนะ';
    const classes = useStyles();

    const [dataList, setDataList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [orderDirection, setOrderDirection] = useState('desc');
    const [orderBy, setOrderBy] = useState('code'); // default column to sort
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [Keyword, setKeyword] = useState('');
    const [typeKey, setTypeKey] = useState(''); // ใช้สำหรับการเลือกประเภทจาก TSSelect2
    const [arrVehicleType, setArrVehicleType] = useState([]);

    useEffect(() => {
        fetchDataList();
    }, [Keyword]);

    const fetchDataList = async () => {
        try {
            const response = await axios.get(`/api/v1/vehicle/vehicletype?name=` + Keyword);

            if (response.data.result === 200) {
                setDataList(response.data.data);
            } else {
                setDataList([]);
            }
        } catch (error) {
            console.error('Error fetching dataList:', error);
            setDataList([]);
        }
    };

    const fetchVehicleTypes = async () => {
        try {
            const response = await axios.get(`/api/v1/vehicle/vehicletype`);
            if (response.data.result === 200) {
                // ปรับข้อมูลให้สอดคล้องกับรูปแบบที่ TSSelect2 ต้องการ
                const formattedData = response.data.data.map(item => ({
                    value: item.vehicleTypeKey,
                    label: item.name
                }));
                setArrVehicleType(formattedData);
            }
        } catch (error) {
            console.error('Error fetching vehicle types:', error);
        }
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedVehicleTypes = () => {
        return dataList.sort((a, b) => {
            if (orderDirection === 'asc') {
                return a[orderBy] < b[orderBy] ? -1 : 1;
            }
            return a[orderBy] > b[orderBy] ? -1 : 1;
        });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedData(null);
        setIsEditing(false);
        setEditIndex(null);
    };

    const handleEdit = (index, _data) => {
        setEditIndex(index);
        setIsEditing(true);
        setSelectedData(_data);
        setModalOpen(true);
    };

    const handleAdd = () => {
        clearForm();
        setModalOpen(true);
    };

    const clearForm = () => {
        setSelectedData({
            code: '',
            name: '',
            vehicleTypeKey: ''
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedData({ ...selectedData, [name]: value });
    };

    const handleSaveChanges = async () => {
        try {
            if (isEditing) {
                await axios.put('/api/v1/vehicle/vehicletype/' + selectedData.vehicleTypeKey, selectedData);
            } else {
                await axios.post('/api/v1/vehicle/vehicletype', selectedData);
            }
            handleCloseModal();
            fetchDataList();
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };

    return (
        <div>
            <Card>
                <CardHeader color="primary">
                    <h4 className={classes.cardTitleWhite}>รายการ{tableText}</h4>
                </CardHeader>
                <CardBody>
                    <div>
                        <Grid>
                            <Col xs={12} sm={12} md={12}>
                                <TSText icon="far fa-edit" label="คำค้นหา" value={Keyword} onChange={e => setKeyword(e.target.value)} />
                            </Col>
                            {/* //Combobox Filter
                                   <Col xs={12} sm={12} md={6}>
                                        <TSSelect2 isClearable={true} label="TypeKey" options={ArrAssetType} value={TypeKey} onChange={e => setTypeKey(e != null ? e.value : '') } />
                                    </Col> 
                                    */}
                        </Grid>

                        {/* Add more fields as necessary for other properties */}
                        <Col xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>

                            <Button2
                                color="success"
                                type="button"
                                onClick={handleAdd}
                            >
                                <h4><i className={"fa fa-plus"}> เพิ่ม{tableText}</i></h4>
                            </Button2>

                        </Col>
                        <TableContainer component={Paper} className={classes.tableContainer}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'code'}
                                                direction={orderBy === 'code' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('code')}
                                            >
                                                รหัส{tableText}
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'name'}
                                                direction={orderBy === 'name' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('name')}
                                            >
                                                ชื่อ{tableText}
                                            </TableSortLabel>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sortedVehicleTypes()
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((data, index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                                <TableCell>
                                                    <Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, data)}>
                                                        {data.code}
                                                    </Button>
                                                </TableCell>
                                                <TableCell>
                                                    <Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, data)}>
                                                        {data.name}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            count={dataList.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </div>
                </CardBody>
                <CardFooter>
                    <Modal isOpen={modalOpen} toggle={handleCloseModal}>
                        <ModalHeader toggle={handleCloseModal}></ModalHeader>
                        <ModalBody>
                            {selectedData && (
                                <Card>
                                    <CardHeader color="primary">
                                        <h4 className={classes.cardTitleWhite}>
                                            {isEditing ? `แก้ไข ${tableText}` : `เพิ่ม ${tableText}`}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <TSText
                                            icon="far fa-edit"
                                            name="code"
                                            label={"รหัส" + tableText}
                                            value={selectedData.code}
                                            onChange={handleInputChange}
                                        />
                                        <TSText
                                            icon="far fa-edit"
                                            name="name"
                                            label={"ชื่อ" + tableText}
                                            value={selectedData.name}
                                            onChange={handleInputChange}
                                        />
                                    </CardBody>
                                    <CardFooter>
                                        <Button2 color="info" type="button" onClick={handleSaveChanges}>
                                            <h4>บันทึก</h4>
                                        </Button2>
                                        <Button2 color="danger" type="button" onClick={handleCloseModal}>
                                            <h4>ยกเลิก</h4>
                                        </Button2>
                                    </CardFooter>
                                </Card>
                            )}
                        </ModalBody>
                    </Modal>
                </CardFooter>
            </Card>
        </div>
    );
};

export default function ProtectedVehicleTypeList(props) {
    return (
        <VehicleAdminGuard>
            <VehicleTypeList {...props} />
        </VehicleAdminGuard>
    );
}
